module.exports = __webpack_public_path__ + "img/banner0.a0dc205f.jpg";